import React, { useState, useEffect } from "react";
import LapseTableRowHead from "./LapseTable/LapseTableRowHead";
import LapseTableData from "./LapseTable/LapseTableData";
import { table } from "../Shared/Styles";

import {
  subTitle,
  summary,
  // summaryName,
  hr,
} from "../Shared/Styles";

export default function Conditions({ policyLapse }) {
  const noLapseBenefits = (
    <div>
      <h3 style={subTitle}>LAPSES</h3>
      <p style={summary}>There are no lapsed benefits.</p>
    </div>
  );
  if (policyLapse.length >= 1) {
    if (Object.values(policyLapse[0]).every(v => !v)) {
      return noLapseBenefits
    } else {
      return (
        <div className="lapseTableComponent">
          <h3 style={subTitle}>LAPSES</h3>
          <div>
            {policyLapse.map((link) => (
              <>
                <div style={summary}>
                  {link?.lifeInsuredFirstName}
                  {""}
                  {link?.lifeInsuredSurName}
                  <hr style={hr} />
                </div>

                <div>
                  <table style={table}>
                    <LapseTableRowHead />

                    <LapseTableData ltd={link?.policyLapseSub} />
                  </table>
                </div>
              </>
            ))}
          </div>
        </div>
      );
    }
  } else {
    return noLapseBenefits
  }
}


